const { HOSTNAME_REGEX } = require('@kentik/ui-shared/util/regex');

export default {
  message: 'Enter a valid hostname',
  fn: (value) => value && value.match(HOSTNAME_REGEX)
};
